module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/1-6f538a3c52cb1b8714da82b6bcf87b15.png";